import React, { useState } from "react";
import moment from "moment-timezone";
import Datetime from "react-datetime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Card, Form, Button, InputGroup } from '@themesberg/react-bootstrap';
import { ChoosePhotoWidget } from "../components/Widgets";
import doctor from "../assets/img/doctor1.png";
import { BASE_URL } from "../constants";

export const GeneralInfoForm = () => {
    const [name, setName] = useState("");
    const [speciality, setSpeciality] = useState("");
    const [availability, setAvailability] = useState("");
    const [gender, setGender] = useState("0"); // 0 for default selection
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [profilePhoto, setProfilePhoto] = useState(null);
    const [profilePhotoPreview, setProfilePhotoPreview] = useState(doctor);

    const handleProfilePhotoChange = (e) => {
        const file = e.target.files[0];
        setProfilePhoto(file);
        if (file) {
            setProfilePhotoPreview(URL.createObjectURL(file));
        }
    };
    
    const handleDateChange = (date) => {
        if (moment(date, 'YYYY-MM-DD', true).isValid()) {
            setAvailability(moment(date).format("YYYY-MM-DD"));
        } else {
            setAvailability("");
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('name', name);
        formData.append('specialty', speciality);
        formData.append('availability[date]', new Date(availability).toISOString());
        formData.append('availability[available]', true);
        formData.append('email', email);
        formData.append('phone', phone);
        formData.append('profilePhoto', profilePhoto);

        try {
             const token = localStorage.getItem('token');
          

    const response = await fetch(`${BASE_URL}/doctors`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        },
        body: formData
    });

            if (!response.ok) {
                throw new Error('Failed to create Doctor');
            }
    
            alert('Doctor created successfully!');
        } catch (error) {
            console.error('Error creating Doctor:', error.message);
        }
    };
    
    return (
        <Card border="light" className="bg-white shadow-sm mb-4">
            <Card.Body>
                <h5 className="mb-4">General information</h5>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md={6} className="mb-3">
                            <Form.Group id="firstName">
                                <Form.Label>Name</Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    placeholder="Enter the doctor's name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                            <Form.Group id="speciality">
                                <Form.Label>Specialty</Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    placeholder="Enter the doctor's specialty"
                                    value={speciality}
                                    onChange={(e) => setSpeciality(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} className="mb-3">
                            <Form.Group id="email">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    required
                                    type="email"
                                    placeholder="name@company.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                            <Form.Group id="phone">
                                <Form.Label>Phone</Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    placeholder="Enter phone number"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} className="mb-3">
                            <Form.Group id="availability">
                                <Form.Label>Availability</Form.Label>
                                <Datetime
                                    dateFormat="MM/DD/YYYY"
                                    timeFormat={false}
                                    value={availability ? moment(availability).format("MM/DD/YYYY") : ""}
                                    onChange={handleDateChange}
                                    renderInput={(props, openCalendar) => (
                                        <InputGroup>
                                            <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="mm/dd/yyyy"
                                                onFocus={openCalendar}
                                                value={availability ? moment(availability).format("MM/DD/YYYY") : ""}
                                                onChange={() => { }}
                                            />
                                        </InputGroup>
                                    )}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={12} xl={4}>
                            <Row>
                                <Col xs={12}>
                                    <ChoosePhotoWidget
                                        title="Select profile photo"
                                        photo={profilePhotoPreview}
                                        onChange={handleProfilePhotoChange}
                                        preview={profilePhotoPreview}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <div className="mt-3">
                        <Button variant="primary" type="submit">Save All</Button>
                    </div>
                </Form>
            </Card.Body>
        </Card>
    );
};
